export default __webpack_public_path__ + "static/media/events-cat-cn.11809aba.webp";